/**
 * AK-938 — куда ведёт строка «Наука → Опыты».
 *
 * Карточка опыта читается в кабинете ПОЛЯ: свой кабинет — когда мы дома, кабинет
 * клиента — когда открыт он (окно клиента). Строку, чей кабинет сейчас не открыт,
 * ведём не в 404, а подсказкой: что сделать, чтобы попасть в опыт.
 */
import type { TrialListItem } from './types';

export type TrialTarget =
  | { ok: true; fieldId: string; trialId: string }
  | { ok: false; reason: string };

export function trialTarget(
  item: TrialListItem,
  clientWindowTenantId: string | null | undefined,
): TrialTarget {
  if (item.access === 'closed') {
    return { ok: false, reason: 'Хозяйство закрыло доступ — опыт открыть нельзя' };
  }
  if (!item.field_id || !item.field_trial_id) {
    return { ok: false, reason: 'Опыт без поля — открыть нечего' };
  }
  const here = clientWindowTenantId
    ? item.field_tenant_id === clientWindowTenantId
    : item.own_cabinet;
  if (!here) {
    return {
      ok: false,
      reason: item.own_cabinet
        ? 'Опыт на вашем поле — выйдите из кабинета клиента, чтобы открыть его'
        : 'Опыт у клиента — войдите к клиенту из CRM, затем откройте «Науку»',
    };
  }
  return { ok: true, fieldId: item.field_id, trialId: item.field_trial_id };
}
